export const dropdownDividerStyle = {
  borderBottom: "1px solid gray",
  paddingTop: ".125rem",
  marginLeft: "2.5%",
  width: "95%"
};
